import { render, staticRenderFns } from "./fccInstituicaoEnsinoSuperior.vue?vue&type=template&id=e1f1e3a4"
import script from "./fccInstituicaoEnsinoSuperior.vue?vue&type=script&lang=js"
export * from "./fccInstituicaoEnsinoSuperior.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports